/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Capacitor } from "@capacitor/core";

type DebugHandler = () => void;

let handlerPromise: Promise<DebugHandler | null> | null = null;

const loadHandler = (): Promise<DebugHandler | null> => {
  if (
    !Capacitor.isNativePlatform() &&
    process.env.REACT_APP_AZURE_B2C_LOGIN_REDIRECT_URI === "http://localhost:3000/"
  ) {
    return import("./DebugAuth").then((m) => m.default);
  }
  if (
    Capacitor.isNativePlatform() &&
    (process.env.REACT_APP_PACKAGE_NAME_ANDROID === "nz.co.farmlands.farmlandspro.dev" ||
      process.env.REACT_APP_PACKAGE_NAME_ANDROID === "nz.co.farmlands.farmlandspro.test") &&
    Capacitor.DEBUG
  ) {
    return import("./DebugAssignAuth").then((m) => m.default);
  }
  return Promise.resolve(null);
};

const onClickDeveloper = async (): Promise<void> => {
  if (!handlerPromise) {
    handlerPromise = loadHandler();
  }
  const handler = await handlerPromise;
  handler?.();
};

export const isIosSimulatorLocalhost = Capacitor.getPlatform() === "ios" && Capacitor.DEBUG;

export const isAndroidSimulatorLocalhost = Capacitor.getPlatform() === "android" && Capacitor.DEBUG;

export default onClickDeveloper;
